var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.755859,
    y: 0.82666,
    width: 57.0706,
    height: 57.0706,
    rx: 9.07941,
    fill: "#EFEFEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4724_21928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8558 30.1829C43.8558 29.1898 43.7596 28.1647 43.5995 27.2036H29.728V32.8739H37.6729C37.3525 34.7 36.2953 36.3017 34.7256 37.3269L39.4669 41.011C42.254 38.4161 43.8558 34.6359 43.8558 30.1829Z",
    fill: "#4280EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7284 44.5348C33.7008 44.5348 37.0325 43.2214 39.4672 40.9789L34.7259 37.3268C33.4125 38.2238 31.7146 38.7364 29.7284 38.7364C25.8841 38.7364 22.6485 36.1415 21.4632 32.6816L16.5938 36.4298C19.0925 41.3953 24.1542 44.5348 29.7284 44.5348Z",
    fill: "#34A353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4629 32.6499C20.8542 30.8239 20.8542 28.8377 21.4629 27.0117L16.5935 23.2314C14.5112 27.3961 14.5112 32.2975 16.5935 36.4301L21.4629 32.6499Z",
    fill: "#F6B704"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7284 20.957C31.8107 20.925 33.861 21.7259 35.3666 23.1675L39.5633 18.9388C36.9044 16.44 33.3804 15.0945 29.7284 15.1265C24.1542 15.1265 19.0925 18.266 16.5938 23.2316L21.4632 27.0118C22.6485 23.5199 25.8841 20.957 29.7284 20.957Z",
    fill: "#E54335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4724_21928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.8321,
    height: 29.4728,
    fill: "white",
    transform: "translate(15.0234 15.0942)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.cc00fb9c348ae9dc68e706d53aab4d9f.svg";
export { ForwardRef as ReactComponent };